import { getIsDarkTheme } from 'owa-fabric-theme';
import getIsDarkModeEnabledInUserSettings from './getIsDarkModeEnabledInUserSettings';
export default function getIsFullOptionDirty() {
    return getIsDarkTheme() !== getIsDarkModeEnabledInUserSettings();
}
//# sourceMappingURL=getIsFullOptionDirty.js.map